import React from "react";
import { Link } from "react-router-dom";

export default function CGV() {
  return (
    <div className="cs-cream py-16 min-h-[80vh]" data-testid="page-cgv">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="cs-eyebrow text-neutral-500">Conditions générales de vente</div>
        <h1 className="cs-h1 mt-3 text-4xl lg:text-5xl">CGV</h1>
        <p className="mt-2 text-[12px] font-mono text-neutral-500">Dernière mise à jour : septembre 2026.</p>

        <section className="mt-10 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 1 — Prestataire</h2>
          <p>
            Les présentes conditions régissent toute prestation vendue par Charbonier Studio, entreprise individuelle
            immatriculée sous le SIRET 94745095300015, dont le siège est situé 702 Chemin d'en Vindé, 32130
            Labastide-Savès (France), joignable à <a href="mailto:contact@charbonierstudio.fr" className="cs-link-underline">contact@charbonierstudio.fr</a>.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 2 — Prestations</h2>
          <p>
            Charbonier Studio propose des prestations de création graphique, mise en page, préparation prépresse
            et fichiers prêts à imprimer, décrites sur les pages du site. Chaque prestation fait l'objet d'une
            fiche détaillant son périmètre et son tarif de départ. Toute demande complémentaire hors périmètre
            fait l'objet d'un avenant proposé avant intervention.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 3 — Prix</h2>
          <p>
            Les prix sont indiqués en euros, toutes taxes comprises. Charbonier Studio applique la franchise en base
            de TVA (article 293 B du CGI) ; à ce titre, la TVA n'est pas facturée.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 4 — Commande</h2>
          <p>
            Toute commande implique l'acceptation sans réserve des présentes CGV. La commande devient définitive
            après validation du récapitulatif et paiement selon les modalités convenues. Pour les prestations
            supérieures au seuil interne du studio, un devis est émis et doit être accepté avant tout paiement.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 5 — Paiement</h2>
          <p>
            Le paiement est effectué en ligne par carte bancaire via Stripe. Selon le montant, il peut être scindé
            en plusieurs étapes (acompte, règlement intermédiaire, solde). Aucun élément définitif n'est livré
            avant réception du solde.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 6 — Délais</h2>
          <p>
            Les délais indiqués sur les fiches sont donnés à titre indicatif et démarrent à réception de tous
            les éléments nécessaires (fichiers, textes, validations). Aucune pénalité de retard n'est due tant que
            le client n'a pas fourni les éléments demandés.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 7 — Livraison</h2>
          <p>
            Les fichiers finaux sont livrés par voie électronique via l'espace client, dès réception du solde.
            Le client dispose de son espace personnel pour retrouver ses commandes et factures.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 8 — Droit de rétractation</h2>
          <p>
            Conformément à l'article L221-28 du Code de la consommation, les prestations personnalisées commandées
            par un consommateur ne peuvent faire l'objet d'un droit de rétractation dès lors que leur exécution a
            commencé avec l'accord exprès du consommateur. Le client accepte donc de renoncer à son droit de
            rétractation en validant sa commande, dès que Charbonier Studio commence à travailler sur son projet.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 9 — Propriété intellectuelle</h2>
          <p>
            Les créations graphiques réalisées font l'objet d'une cession d'usage au client pour l'exploitation
            décrite dans la commande (impression, diffusion numérique). Toute exploitation hors périmètre nécessite
            un avenant. Charbonier Studio conserve la possibilité de présenter les créations dans son portfolio
            sauf demande contraire du client.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 10 — Responsabilité</h2>
          <p>
            Charbonier Studio met tout en œuvre pour livrer des fichiers conformes aux consignes techniques
            transmises. Le client demeure responsable de la validation finale de son fichier avant impression et
            de la fourniture d'éléments (textes, images, spécifications imprimeur) exacts et complets.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 11 — Données personnelles</h2>
          <p>
            Les données collectées lors d'une commande sont utilisées uniquement pour l'exécution de la prestation
            et son suivi. Détails complets dans notre <Link to="/confidentialite" className="cs-link-underline">politique de confidentialité</Link>.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Article 12 — Litiges</h2>
          <p>
            Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera
            recherchée avant toute action contentieuse. À défaut, les tribunaux français compétents seront saisis.
          </p>
          <p>
            Médiation de la consommation : conformément à l'article L612-1 du Code de la consommation, le
            consommateur peut recourir gratuitement au service de médiation MEDICYS
            (<a href="https://medicys.fr" target="_blank" rel="noreferrer" className="cs-link-underline">medicys.fr</a>).
            Plateforme européenne de règlement en ligne des litiges :
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="cs-link-underline"> ec.europa.eu/consumers/odr</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
